/* src/app/modules/supportTickets/tickets.component.css */
#customers {
  font-family:
    "Inter Tight",
    Arial,
    Helvetica,
    sans-serif;
  border-collapse: collapse;
  width: 100%;
}
h2,
p {
  font-family:
    "Inter Tight",
    Arial,
    Helvetica,
    sans-serif;
  border-collapse: collapse;
  width: 100%;
}
#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}
#customers tr:hover {
  background-color: #ddd;
}
#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}
.conversation-left {
  background-color: beige;
}
.conversation-right {
  background-color: aliceblue;
}
/*# sourceMappingURL=tickets.component.css.map */
